import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, Popover, Table, Tag } from "antd";
import { Badge, Space, Switch } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../helpers/axios";
import { toast } from "react-toastify";
import { clearLocalStorageExceptOne } from "../../helpers/constants";

const LoanTabDatas = (props) => {
    const { data, type, tabIndex, pagination, hadlePagination } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const pagePermission = location?.state;
    const [listDetails, setListDetails] = useState([]);
    const [columnType, setColumnType] = useState();
    const moment = require("moment");
    const [delModal, setDelModal] = useState(false);
    const [delId, setDelid] = useState(null);
    const [SelectiveObjParams, setSelectiveObjParams] = useState({
        param1: "after_update",
        param2: "before_update",
    });

    useEffect(() => {
        if (tabIndex == 1) {
            setSelectiveObjParams({
                param1: "schedule",
                param2: "after_update",
            });
        } else {
            setSelectiveObjParams({
                param1: "after_update",
                param2: "before_update",
            });
        }
    }, [tabIndex]);

    //console.log("SelectiveObjParams", SelectiveObjParams);

    const sortedDataSource = [...listDetails];

    const customLocale = {
        emptyText: type == "disbursement" ? "No Disbursement Made" : "No Data",
    };

    const GetFilterArray = (arr) => {
        const results = arr.filter((element) => {
            if (Object.keys(element).length !== 0) {
                return true;
            }

            return false;
        });
        return results;
    };
    const GetTextFormatted = (text, type) => {
        const temp = text !== undefined && text !== null && text !== "" ? text : "--";
        return temp;
    };

    const FormatDate = (text) => {
        const temp =
            text !== undefined && text !== null && text !== ""
                ? moment(text, "YYYY-MM-DD").format("DD-MM-YYYY")
                : "Further Notice";
        return temp;
    };

    const columns = [
        {
            title: "Date and Time",
            dataIndex: "date_time",
            fixed: window.innerWidth < 767 ? " " : "left",
            width: 100,
            sorter: false,
            render: (text, record) => {
                if (text) {
                    return {
                        children: (
                            <p className="font-[700]">
                                {moment(text?.after_update).format("DD-MM-YYYY")},{" "}
                                {moment(text?.after_update).format("HH:mm")}
                                { }
                            </p>
                        ),
                    };
                }
            },
        },
        {
            title: "Loan Provide Name",
            dataIndex: "provider",
            sorter: false,
            width: 100,
            render: (text, { loan_type }) => (
                <Tag
                    className="mb-2 text-center"
                    style={{ width: "80px" }}
                    color={"#DDEAFF"}
                    key={text?.after_update}
                >
                    <span className="font-[600]" style={{ color: "#0560FB" }}>
                        {text?.after_update?.toUpperCase()}
                    </span>
                </Tag>
            ),
        },
        {
            title: "Loan Product Name",
            dataIndex: "product",
            sorter: false,
            width: 130,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p className="text-[#0560FB] text-[13px] font-[700] cursor-pointer">
                                {text.after_update}
                            </p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Interest Type",
            dataIndex: "lt",
            sorter: false,
            width: 40,
            render: (text, record) => {
                return {
                    children: (
                        <div>
                            <p>{record?.type}</p>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Interest Rate",
            dataIndex: "interest",
            sorter: false,
            width: 90,
            render: (text, record) => {
                //console.log("INTERESTRECORD", text, SelectiveObjParams);
                return {
                    children: (
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignContent: "center",
                                }}
                            >
                                {tabIndex == 1 ? (
                                    <p>{`${GetTextFormatted(
                                        text[SelectiveObjParams?.param2]?.schedule?.interest
                                    )}`}</p>
                                ) : (
                                    <p>{`${GetTextFormatted(
                                        text[SelectiveObjParams?.param1]?.interest
                                    )} `}</p>
                                )}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignContent: "center",
                                }}
                            >
                                <p
                                    style={{
                                        color: "red",
                                    }}
                                >{`${GetTextFormatted(
                                    text[SelectiveObjParams?.param2]?.interest
                                )} `}</p>
                            </div>
                        </div>
                    ),
                };
            },
        },
        {
            title: "Available From",
            dataIndex: "interest",
            sorter: false,
            width: 140,
            render: (text, record) => {
                return (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            {tabIndex == 1 ? (
                                <p>{`${GetTextFormatted(
                                    FormatDate(
                                        text[SelectiveObjParams?.param2]?.schedule?.startDate
                                    ),
                                    "Date"
                                )} to ${GetTextFormatted(
                                    FormatDate(
                                        text[SelectiveObjParams?.param2]?.schedule?.endDate
                                    ),
                                    "Date"
                                )} `}</p>
                            ) : (
                                <p>{`${GetTextFormatted(
                                    FormatDate(text[SelectiveObjParams?.param1]?.startDate),
                                    "Date"
                                )} to ${GetTextFormatted(
                                    FormatDate(text[SelectiveObjParams?.param1]?.endDate),
                                    "Date"
                                )} `}</p>
                            )}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <p
                                style={{
                                    color: "red",
                                }}
                            >{`${GetTextFormatted(
                                FormatDate(text[SelectiveObjParams?.param2]?.startDate),
                                "Date"
                            )} to ${GetTextFormatted(
                                FormatDate(text[SelectiveObjParams?.param2]?.endDate, "Date")
                            )} `}</p>
                        </div>
                    </div>
                );
            },
        },

        {
            title: "Min. Loan",
            dataIndex: "interest",
            sorter: false,
            width: 140,
            render: (text, record) => {
                return (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            {tabIndex == 1 ? (
                                <p>
                                    {`$${GetTextFormatted(
                                        text[SelectiveObjParams?.param2]?.schedule
                                            ?.minimum_loan_amount
                                    )} else + $${GetTextFormatted(
                                        text[SelectiveObjParams?.param2]?.schedule?.admin_fee
                                    )}Admin Fee `}
                                </p>
                            ) : (
                                <p>{`$${GetTextFormatted(
                                    text[SelectiveObjParams?.param1]?.minimum_loan_amount
                                )} else +  $${GetTextFormatted(
                                    text[SelectiveObjParams?.param1]?.admin_fee
                                )} Admin Fee `}</p>
                            )}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <p
                                style={{
                                    color: "red",
                                }}
                            >{`$${GetTextFormatted(
                                text[SelectiveObjParams?.param2]?.minimum_loan_amount
                            )} else + $${GetTextFormatted(
                                text[SelectiveObjParams?.param2]?.admin_fee
                            )} Admin Fee`}</p>
                        </div>
                    </div>
                );
            },
        },
        {
            title: "Remarks",
            dataIndex: "interest",
            sorter: false,
            width: 100,
            render: (text, record) => {
                const BEFORE = tabIndex == 1 ? text[SelectiveObjParams?.param2]?.schedule : text[SelectiveObjParams?.param2]
                const AFTER =
                    tabIndex == 1
                        ? text[SelectiveObjParams?.param2]?.schedule
                        : text[SelectiveObjParams?.param1];
                //console.log("REMARKS", BEFORE?.remarks2, AFTER?.remarks2);
                return (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <p>{GetTextFormatted(AFTER?.remarks1)}</p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <p
                                style={{
                                    color: "red",
                                }}
                            >{GetTextFormatted(BEFORE?.remarks1)}</p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <p>{GetTextFormatted(AFTER?.remarks2)}</p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                            }}
                        >
                            <p
                                style={{
                                    color: "red",
                                }}
                            >{GetTextFormatted(BEFORE?.remarks2)}</p>
                        </div>
                    </div>
                );
            },
        },
    ];

    const onChange = (pagination, filters, sorter, extra) => {
        //console.log("params", pagination, filters, sorter, extra);
    };

    useEffect(() => {
        let listData = data;
        if (listData != undefined && listData.length > 0) {
            setListDetails(listData);
        } else {
            setListDetails([]);
        }
    }, [data]);

    // useEffect(() => {
    //     setColumnType(columns);
    // }, []);
    return (
        <div className="table-container">
            <Modal
                title="Delete Application"
                centered
                open={delModal}
                onOk={async () => {
                    const tokenId = localStorage.getItem("dealerModuleToken");
                    const resp = await axios.delete(`/loan/application/delete/${delId}`, {
                        headers: {
                            Authorization: `Bearer ${tokenId}`,
                        },
                    });
                    if (resp) {
                        props.fetchLoanCase();
                        toast.success("Deleted Successfully!!!", { autoClose: 2500 });
                        setDelModal(false);
                    }
                }}
                onCancel={() => setDelModal(false)}
                wrapClassName="delApplModal"
                okText={
                    <>
                        <DeleteOutlined />
                        &nbsp;Delete
                    </>
                }
            >
                <p>Are you sure want to delete?</p>
            </Modal>
            <Table
                showSorterTooltip={false}
                dataSource={sortedDataSource}
                columns={columns}
                pagination={{
                    current: pagination.page,
                    pageSize: pagination.pageSize,
                    total: pagination.total
                }}
                scroll={{ x: type != "expired" ? 1300 : 1300 }}
                rowKey={(record, index) => index}
                locale={customLocale}
                className="custom-table"
                onChange={(val) => hadlePagination(val)}
            />
        </div>
    );
};

export default LoanTabDatas;
